import type { ErrorBoundaryPropsWithRender } from "react-error-boundary";

import { QueryErrorResetBoundary } from "@tanstack/react-query";
import { ErrorBoundary } from "react-error-boundary";

type ApiErrorBoundaryProps = Pick<
  ErrorBoundaryPropsWithRender,
  "fallbackRender" | "children"
>;

export const ApiErrorBoundary = ({
  fallbackRender,
  children,
}: ApiErrorBoundaryProps) => (
  <QueryErrorResetBoundary>
    {({ reset }) => (
      <ErrorBoundary fallbackRender={fallbackRender} onReset={reset}>
        {children}
      </ErrorBoundary>
    )}
  </QueryErrorResetBoundary>
);
